
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import OrderConfirmation from './components/OrderConfirmation';
import CheckoutForm from './components/CheckoutForm';
import OrderSummary from './components/OrderSummary';

export default function CheckoutPage() {
  const { items, clearCart } = useCart();
  const [searchParams] = useSearchParams();

  const isSuccess = searchParams.get('success') === 'true';
  const isCanceled = searchParams.get('canceled') === 'true';

  // Clear the cart only after a successful checkout
  useEffect(() => {
    if (isSuccess) {
      clearCart();
    }
  }, [isSuccess, clearCart]);

  // Show confirmation page after a successful payment
  if (isSuccess) {
    return <OrderConfirmation />;
  }

  // All items are sold out — block checkout
  return (
    <>
      <SEOHead
        title="Checkout | ignight Luxury Concrete Candles"
        description="Complete your purchase of luxury travel-inspired concrete candles with pure essential oils."
        keywords="checkout, buy candles, luxury candles, concrete candles"
      />
      <div className="min-h-screen bg-[#0B1B3A] flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center px-4 pt-24 pb-16">
          <div className="text-center">
            <div className="w-20 h-20 rounded-full bg-[#2A1A1A] flex items-center justify-center mx-auto mb-6">
              <i className="ri-close-circle-line text-[#E8A0A0] text-3xl"></i>
            </div>
            <h1 className="text-2xl font-serif text-[#F5F0E8] mb-3">
              All Items Are Sold Out
            </h1>
            <p className="text-sm text-[#8A9BB5] mb-8 max-w-xs mx-auto">
              Our entire collection is currently unavailable for purchase. Please check back later.
            </p>
            <Link
              to="/"
              className="inline-flex items-center px-8 py-3 bg-[#D4C5A9] text-[#0B1B3A] font-medium rounded-lg hover:bg-[#E5D6BA] transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Back to Home
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
